export default "__VITE_ASSET__R2W7G4U5__"